import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["label", "errorMessage", "required"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { Input } from '../../../input';
import styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FormFieldInputComponent = /*#__PURE__*/React.forwardRef(function FormField(props, ref) {
  const {
      label,
      errorMessage,
      required = false
    } = props,
    inputProps = _objectWithoutProperties(props, _excluded);
  const labelClasses = clsx(styles['label'], {
    [styles['required']]: required
  });
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    children: [label && /*#__PURE__*/_jsx("label", {
      className: labelClasses,
      children: label
    }), /*#__PURE__*/_jsx(Input, _objectSpread({}, inputProps)), errorMessage && /*#__PURE__*/_jsx("div", {
      className: styles['error_message'],
      children: errorMessage
    })]
  });
});

/**
 * DEPRECATED
 *
 * Используйте простой FromField
 */
export const FormFieldInput = /*#__PURE__*/React.memo(FormFieldInputComponent);